import { useState, useEffect } from "react";
import { getAllLists } from "../api/list.api";
import ListCard from "../components/ListCard";
import Marquee from "../components/Marquee";
import ReelLoader from "../components/LoadingReel";

const Lists = () => {
  const [allLists, setAllLists] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const lists = await getAllLists();
        setAllLists(lists);
      } catch (error) {
        console.log("Error front end: " + error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="lists-container">
      {isLoading && <ReelLoader />}
      <div className={`lists-content ${isLoading ? "hide" : "show"}`}>
        <Marquee title={"FELICE COMPILATIONS"} />

        <div className="lists-hero-text">
          <div className="lists-hero-title"></div>
        </div>

        <div className="lists-list-card-wrapper">
          {allLists.map((list) => (
            <ListCard list={list} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Lists;
